import controller from './BreadcrumbsProfileController';
import template from './breadcrumbsProfile.html';

function directive() {
  return {
    template,
    restrict: 'E',
    controller: 'BreadcrumbsProfileController'
  };
}

export default function (ngModule) {
  ngModule.directive('breadcrumbsProfile', directive);
  controller(ngModule);
}
